import styled from "styled-components";

export default styled.span`
    padding: 4px 8px;
    border-radius: 4px;

    &.positive {
        background-color: ${(props) => props.theme.bqmqVoteScore1};
        font-weight: 500;
    }

    &.negative {
        background-color: ${(props) => props.theme.bqmqVoteScore5};
        font-weight: 500;
    }
`;
